<template>
	<ul class="!p-0 !m-0 grid grid-cols-palette-design gap-0.5">
		<li v-for="(activePaletteVariant, index) in activeSizeVariants" class="flex flex-col justify-center items-center">
			<button
				type="button"
				@click="selectAcitveSizeVariantIndex(index)"
				:class="[
					'relative group border-solid !p-0.5 rounded-full border-design border-transparent',
					activeDesignIndex === index && 'border-zinc-700',
				]"
				:aria-label="`${activePaletteVariant.title} Button`"
			>
				<div
					class="w-8 h-8 rounded-full bg-cover bg-no-repeat bg-center"
					:style="{
						backgroundImage: activePaletteVariant.hasSwatch ? `url('${activePaletteVariant.url}')` : 'none',
						backgroundColor: !activePaletteVariant.hasSwatch ? activePaletteVariant.hex : '#f5f5f5',
					}"
				>
					<span
						class="group-hover:opacity-100 select-none pointer-events-none transition-opacity text-sm bg-gray-600 px-1 text-white absolute whitespace-nowrap left-1/2 -translate-x-1/2 z-10 -bottom-6 opacity-0"
					>
						{{ activePaletteVariant.title }}
					</span>
				</div>
			</button>
		</li>
	</ul>
</template>
<script setup>
import { storeToRefs } from 'pinia'

import { usePaletteBuilderStore } from '@stores'

const props = defineProps({})

const store = usePaletteBuilderStore()
const { activeSizeVariants, activeDesignIndex, activeDesign } = storeToRefs(store)
const { selectAcitveSizeVariantIndex } = store
</script>
